import { apiFetch } from './client';

/**
 * Feature key for the Activity Metrics dashboard. The server-side registry in
 * `PortalFeatures` is the source of truth for known keys.
 */
export const ACTIVITY_METRICS_FEATURE_KEY = 'activityMetrics';

/**
 * Per-user feature access map: every registered feature key with the caller's
 * granted state. Features are default-deny — access is granted explicitly by Ops
 * (controlled rollout). This map drives UI visibility only; the backend enforces
 * the grant independently on every feature endpoint (403 ACCESS_DENIED).
 */
export interface PortalFeatures {
  features: Record<string, boolean>;
}

export async function getPortalFeatures(): Promise<PortalFeatures> {
  return apiFetch<PortalFeatures>('/v1/portal-features');
}
